import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import '../assets/styles/Main.scss';
import personalImage from '../assets/images/personal.jpg';
function Main() {

  return (
    <div className="container">
      <div className="about-section">
        <div className="image-wrapper">
          <img src={personalImage} alt="Avatar" />
        </div>
        <div className="content">
          <div className="social_icons">
            <a href="https://github.com/alharithali-newtech/github/" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://www.linkedin.com/in/al-harith-ali-al-qadmi/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          </div>
          <h1>Alharith Ali</h1>
          <p>Senior Network and Security Engineer</p>

          <div className="mobile_social_icons">
            <a href="https://github.com/alharithali-newtech/github/" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://www.linkedin.com/in/al-harith-ali-al-qadmi/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;
